import { Dialog } from '@eb/eds-dialog';
import { Modal } from '@eb/eds-modal';
import React, { FunctionComponent } from 'react';
import { ControlledProps, OverlayProps } from '../../types';
import { dynaMount } from '../utils/mountComponent';

const OVERLAY_TYPE_MAP: { [key: string]: FunctionComponent } = {
    dialog: Dialog,
    modal: Modal,
};

const Overlay = (props: OverlayProps) => {
    const { options } = props;
    let component = null;

    if (options) {
        const { kind, ...overlayOptions } = options;
        const OverlayType = OVERLAY_TYPE_MAP[kind];

        component = <OverlayType {...overlayOptions} />;
    }

    return component;
};

const getOverlayProps = (props: ControlledProps): OverlayProps => {
    const { overlayOptions } = props;

    return { options: overlayOptions };
};

const OverlayRoot = (
    props: ControlledProps,
): JSX.Element | React.ReactPortal => {
    const overlayProps = getOverlayProps(props);

    return dynaMount(
        {
            Component: Overlay,
            containerId: 'listings-root__overlay',
        },
        overlayProps,
    );
};

export default OverlayRoot;
